import { useQuery, QueryClient } from '@tanstack/react-query';
import { queryKeys } from 'src/hooks/dataHooks/queryKeys.js';
import { request } from 'src/utilities/axios-utils.js';

//----------------------------------------------------------------

const queryClient = new QueryClient();

const fetchAppStatus = async (checkStatus) => {
  const defaultResponse = { appStatus: 'Live' };
  const isStaging = 'arpelife-prod-webapp-ae-01-stg.azurewebsites.net' === window.location.hostname;

  if (!checkStatus || isStaging) {
    return defaultResponse;
  }
  const response = await request({ url: '/status', method: 'GET' });
  if (200 === response.status) {
    return response.data;
  } else {
    return defaultResponse;
  }
};

export const useCheckAppStatus = () => {
  const checkStatus = 'true' === import.meta.env.VITE_CHECK_APP_STATUS;
  return useQuery({
    queryKey: [queryKeys.CHECK_APP_STATUS],
    queryFn: async () => await fetchAppStatus(checkStatus),
    refetchOnWindowFocus: false,
  });
};
